export default {"src":"/_next/static/media/Bullion.3fe40491.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};